import axios from 'axios';

import 'bootstrap';
import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

import consumer from '../channels/consumer';
import Toaster from '../lib/toaster';

export default class extends Controller {
  static targets = [];

  connect() {
    const self = this;
    const asyncTasksPath = self.data.get('baseUrl');
    axios.get(asyncTasksPath).then((res) => {
      res.data.entries.forEach((task) => {
        const errors = this.constructor.parseErrors(task);
        const content = this.constructor.toastContent(task, errors);
        const options = {
          title: task.name,
          className: errors.length > 0 ? 'danger' : 'success',
          content,
        };
        const id = `async_task_id_${task.id}`;
        Toaster.showToast(options, id);
      });
    });
    self.subscription = consumer.subscriptions.create(
      {
        channel: 'AsyncTasksChannel',
        room: window.currentUserId || 0,
      },
      {
        connected: self.constructor.channelConnected.bind(this),
        disconnected: self.constructor.channelDisconnected.bind(this),
        received: self.messageReceived.bind(this),
      }
    );
  }

  static channelConnected() {}

  static channelDisconnected() {}

  static parseErrors(task) {
    let errors = [];
    if (task && task.result && task.result.processed) {
      Object.values(task.result.processed).forEach((x) => {
        if (x.status === 'failed' && x.errors) {
          errors = [...errors, ...x.errors];
        }
      });
    }
    return errors;
  }

  static toastContent(task, errors) {
    let content = task.summary;
    if (errors && errors.length > 0) {
      content += `<ul><li>${errors.join('</li><li>')}</li></ul>`;
    }
    return content;
  }

  messageReceived(data) {
    const message = JSON.parse(data);
    const id = `async_task_id_${message.id}`;
    const toast = $(`#${id}`);
    const errors = this.constructor.parseErrors(message);
    const content = this.constructor.toastContent(message, errors);
    if (toast.length > 1) {
      toast.get(1).remove();
    }
    if (toast.length !== 0) {
      toast.find('.toast-body').html(content);
    } else {
      const options = {
        title: message.name,
        className: errors.length > 0 ? 'danger' : 'success',
        content,
        delay: errors.length > 0 ? 400000 : 5000,
      };
      Toaster.showToast(options, id);
    }
  }
}
